export var isClearResponse = function isClearResponse(message) {
  return message.error === null && typeof message.id === 'number';
};